<template>
  <activity-edit-main></activity-edit-main>
</template>

<script>
import ActivityEditMain from './components/activity-edit-main'
export default {
  name: 'EditActivity',
  components: {
    ActivityEditMain
  }
}
</script>

<style lang="stylus" scoped>

</style>
